import type { Profile, Recipe } from "../types";

export const demoProfiles: Profile[] = [
  { id: "profile-claire", displayName: "Claire", email: "claire@demo.mijote.fr" },
  { id: "profile-mamie", displayName: "Mamie Jeanne", email: "jeanne@demo.mijote.fr" },
  { id: "profile-lucas", displayName: "Lucas", email: "lucas@demo.mijote.fr" },
];

export const demoUser = demoProfiles[0]!;

const ingredient = (
  id: string,
  position: number,
  name: string,
  quantity?: string,
  unit?: string,
  note?: string,
) => ({ id, position, name, quantity, unit, note });

const step = (
  id: string,
  position: number,
  instruction: string,
  illustrationId: string,
  durationMinutes?: number,
) => ({ id, position, instruction, illustrationId, durationMinutes });

export const demoRecipes: Recipe[] = [
  {
    id: "gateau-pommes",
    author: demoProfiles[1]!,
    title: "Gâteau moelleux aux pommes",
    description: "Le gâteau du dimanche de Mamie Jeanne, fondant et délicatement parfumé à la cannelle.",
    categories: ["Dessert", "Goûter"],
    servings: 8,
    prepMinutes: 20,
    cookMinutes: 35,
    difficulty: "facile",
    photoUrl:
      "https://images.unsplash.com/photo-1562007908-17c67e878c88?auto=format&fit=crop&w=1200&q=75",
    visibility: "shared",
    sharedGroups: [],
    sharedWith: [],
    ingredients: [
      ingredient("gp-1", 0, "Pommes", "4"),
      ingredient("gp-2", 1, "Farine", "200", "g"),
      ingredient("gp-3", 2, "Sucre roux", "120", "g"),
      ingredient("gp-4", 3, "Œufs", "3"),
      ingredient("gp-5", 4, "Beurre fondu", "100", "g"),
      ingredient("gp-6", 5, "Levure chimique", "1", "sachet"),
      ingredient("gp-7", 6, "Cannelle", "1", "c. à café", "facultatif"),
    ],
    steps: [
      step("gps-1", 0, "Éplucher les pommes puis les couper en lamelles fines.", "peel", 8),
      step("gps-2", 1, "Fouetter les œufs et le sucre jusqu’à ce que le mélange blanchisse.", "whisk", 4),
      step("gps-3", 2, "Ajouter le beurre, la farine et la levure. Mélanger doucement.", "mix", 4),
      step("gps-4", 3, "Incorporer les pommes et verser dans un moule beurré.", "pour", 4),
      step("gps-5", 4, "Cuire 35 minutes à 180 °C. Laisser tiédir avant de servir.", "bake", 35),
    ],
    createdAt: "2026-07-19T09:20:00.000Z",
    updatedAt: "2026-07-20T17:10:00.000Z",
    isFavorite: true,
  },
  {
    id: "poulet-citron",
    author: demoProfiles[2]!,
    title: "Poulet citron & herbes",
    description: "Un plat familial parfumé, avec des pommes de terre dorées dans le même plat.",
    categories: ["Plat", "Four"],
    servings: 4,
    prepMinutes: 15,
    cookMinutes: 45,
    difficulty: "moyen",
    photoUrl:
      "https://images.unsplash.com/photo-1532550907401-a500c9a57435?auto=format&fit=crop&w=1200&q=75",
    visibility: "shared",
    sharedGroups: [],
    sharedWith: [],
    ingredients: [
      ingredient("pc-1", 0, "Cuisses de poulet", "4"),
      ingredient("pc-2", 1, "Pommes de terre", "700", "g"),
      ingredient("pc-3", 2, "Citron bio", "1"),
      ingredient("pc-4", 3, "Thym", "4", "brins"),
      ingredient("pc-5", 4, "Huile d’olive", "2", "c. à soupe"),
    ],
    steps: [
      step("pcs-1", 0, "Laver les pommes de terre et couper les plus grosses en deux.", "wash", 5),
      step("pcs-2", 1, "Disposer le poulet et les pommes de terre dans un plat.", "plate", 5),
      step("pcs-3", 2, "Ajouter le citron, le thym, l’huile, le sel et le poivre.", "season", 5),
      step("pcs-4", 3, "Enfourner 45 minutes à 200 °C, jusqu’à belle coloration.", "bake", 45),
    ],
    createdAt: "2026-07-17T18:00:00.000Z",
    updatedAt: "2026-07-18T11:45:00.000Z",
    isFavorite: false,
  },
  {
    id: "tartines-tomates",
    author: demoUser,
    title: "Tartines tomates minute",
    description: "Mon déjeuner express pour les jours où le temps manque.",
    categories: ["Rapide", "Végétarien"],
    servings: 2,
    prepMinutes: 8,
    cookMinutes: 3,
    difficulty: "facile",
    visibility: "private",
    sharedGroups: [],
    sharedWith: [],
    ingredients: [
      ingredient("tt-1", 0, "Pain de campagne", "4", "tranches"),
      ingredient("tt-2", 1, "Tomates mûres", "2"),
      ingredient("tt-3", 2, "Fromage frais", "100", "g"),
      ingredient("tt-4", 3, "Basilic", "6", "feuilles"),
    ],
    steps: [
      step("tts-1", 0, "Faire griller légèrement les tranches de pain.", "pan-fry", 3),
      step("tts-2", 1, "Couper les tomates en petits dés.", "cut", 3),
      step("tts-3", 2, "Tartiner le fromage, ajouter les tomates et le basilic.", "plate", 2),
      step("tts-4", 3, "Assaisonner et servir aussitôt.", "serve"),
    ],
    createdAt: "2026-07-21T11:30:00.000Z",
    updatedAt: "2026-07-21T11:30:00.000Z",
    isFavorite: true,
  },
];
